export default "__VITE_PUBLIC_ASSET__aed2ac8a__"